import { render, staticRenderFns } from "./CACA-Senior.vue?vue&type=template&id=1a508eb9&scoped=true"
import script from "./CACA-Senior.vue?vue&type=script&lang=js"
export * from "./CACA-Senior.vue?vue&type=script&lang=js"
import style0 from "./CACA-Senior.vue?vue&type=style&index=0&id=1a508eb9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a508eb9",
  null
  
)

export default component.exports